import React from 'react';
import { AlertDialog, AlertDialogButton } from 'react-onsenui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { refreshConnexion } from '../../../actions/connexionActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


class ServerErrorModal extends React.Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.message = this.message.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            open: this.props.show || false
        }
    }

    componentDidUpdate(prevProps) {
        if(!_.isEqual(prevProps.error, this.props.error)) {
            this.setState({open: !_.isUndefined(this.props.error) && !_.isNull(this.props.error)});
        }
    }

    close() {
        this.setState({open: false});
    }

    message() {
        if(_.isObject(this.props.error)) {
            const {code, data} = this.props.error
            switch(code) {
                case 400:
                    return data['hydra:description'];
                default: return 'Une erreur est survenue, veuillez réessayer plus tard';
            }
        }
    
        return 'Une erreur est survenue, veuillez réessayer plus tard';
    }

    render() {
        return (
            <AlertDialog isOpen={this.state.open} onCancel={this.close}>
                <div className="alert-dialog-title" style={{textAlign: 'center', marginBottom: '10px'}}>
                    <h6 style={{marginBottom: 0, color: '#004586', fontWeight: '700', fontFamily: 'fff-equipe'}}>Oups !</h6>
                </div>
                <div className="alert-dialog-content" style={{fontSize: '14px', textAlign: 'center', marginTop: 0, color: '#004586', fontFamily: 'fff-equipe'}}>
                    {this.message()}
                </div>
                <div className="alert-dialog-footer">
                    <AlertDialogButton onClick={this.handleClick}>
                        <span style={{fontWeight: '700', textAlign: 'center', color: '#004586', fontFamily: 'fff-equipe'}}>Ok</span>
                    </AlertDialogButton>
                </div>
            </AlertDialog>
        );
    }

    handleClick(){
        const {error} = this.props;
        if(_.isObject(error)) {
            switch(error.code) {
                case 401:
                    localStorage.clear();
                    this.props.refreshConnexion();
                break;
                default: 
            }
        }

        this.close();
        this.props.history.push('/matches');
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({refreshConnexion}, dispatch);

ServerErrorModal.propTypes = {
    error: PropTypes.object, 
    refreshConnexion: PropTypes.func.isRequired
}

export default withRouter(connect(null, mapDispatchToProps)(ServerErrorModal));